/**
 * NetworkCurrency entity class
 */

/**
 * NetworkCurrencyFactory
 * returns NetworkCurrency entity class
 *
 * @class NetworkCurrencyFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.NetworkCurrency} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NetworkCurrencyFactory
 */
/* @ngInject */
export default function NetworkCurrencyFactory (Currency, onOffMixin) {
  /* === NetworkCurrency class === */

  /**
   * NetworkCurrency model
   *
   * @class NetworkCurrency
   * @classdesc NetworkCurrency model
   * @memberof models
   * @see models
   * @extends models.Currency
   * @param {Object} [object] - initial object, containing NetworkCurrency entity fields
   * @return {models.NetworkCurrency} NetworkCurrency entity
   */
  function NetworkCurrency () {
    var obj = Currency.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  NetworkCurrency.prototype = Object.create(Currency.prototype)
  NetworkCurrency.prototype.constructor = NetworkCurrency

  /* === NetworkCurrency instance methods & fields === */

  Object.assign(NetworkCurrency.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Currency#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      after: false,
      enabled: Boolean,
      network: 'Network',
      space: false,
      symbol: String
    },

    /**
     * url template
     *
     * @memberof models.NetworkCurrency#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::network.id}}/currencies/{{::id}}'

  }, onOffMixin)

  /* === NetworkCurrency static methods & fields === */

  // copy all static methods from Currency class
  Object.assign(NetworkCurrency, Currency)
  NetworkCurrency._name = 'NetworkCurrency'
  NetworkCurrency.init()

  // permissions
  NetworkCurrency.access = {
    view: 'viewNetworkCurrency',
    edit: 'editNetworkCurrency'
  }

  /**
   * Load all network currencies
   *
   * @memberof models.NetworkCurrency
   * @param  {String|Object} urlObj - scope for {@link models.Entity#_urlTemplate}
   * @param {Boolean} concat - concat currenciesDisabled with currenciesEnabled
   * @return {Promise} promise
   */
  NetworkCurrency.loadAll = function (urlObj, concat = true) {
    var { network } = urlObj // get network from url object
    return this.load(urlObj, {
      currenciesDisabled: [NetworkCurrency],
      currenciesEnabled: [NetworkCurrency]
    }).then(
      data => {
        if (!data) return undefined
        if (!concat) return data

        data.currenciesDisabled.forEach(c => { c.enabled = false })
        data.currenciesEnabled.forEach(c => { c.enabled = true })

        var arr = data.currenciesDisabled.concat(data.currenciesEnabled)
        arr.forEach(c => { c.network = network })

        return arr
      }
    )
  }

  return NetworkCurrency
}
